import * as React from 'react';
import { ISearchResultHitDTO } from '../../DTO/search';

interface IProps {
    result: ISearchResultHitDTO;
    hideCategories: boolean;
    onClick: (hitId) => void;
}

export class Result extends React.Component<IProps, any> {
    render() {
        var { result, onClick, hideCategories } = this.props;
        const hitOnClick = () => onClick(result.hitId);

        return (
            <li className={"adage-search-results-item" + (result.isBestBet ? " best-bet" : "")}>
                <div className={result.searchResultImage != '' && result.searchResultImage != null ? "preview-card-main" : "adage-search-result-preview-card-main"}>
                    {result.searchResultImage != '' && result.searchResultImage != null &&
                        <div className="preview-card-section">
                            <div className="preview-card-image">
                                <img src={result.searchResultImage} alt={result.title} />

                            </div>
                        </div>
                    }
                    <div className="preview-card-section">
                        <a className="adage-search-results-item-link" href={result.url} onClick={hitOnClick}>
                            <h3 dangerouslySetInnerHTML={{ __html: result.title }}></h3>
                        </a>
                        <p className="adage-search-results-item-description" dangerouslySetInnerHTML={{ __html: result.description }}></p>
                        {result.categories && !hideCategories ?
                            <div className="adage-search-results-item-categories">
                                {result.categories.map((x, index) => this.renderCategory(x, index))}
                            </div>
                            : null}
                    </div>

                </div>
            </li >
        )
    }

    renderCategory(category: string, index: number) {
        return (<span key={category + '-' + index} className="tag">{category}</span>);
    }
}